<div class="relative">
  <div class="container w-[260px] min-w-full">
    <div class="w-full flex flex-col sm:flex-row sm:justify-between border-b border-[#bb0021] pb-2">
      <div class="flex items-center gap-3 w-full">
        <div>
          <tui-svg src="tuiIconArchive" style="color: black;"></tui-svg>
        </div>
        <div>
          <h3 class="flex items-center text-black text-[1.5rem] font-bold">Inventory</h3>
        </div>
      </div>
      <div class="flex gap-2 mt-3 sm:mt-0">
        <div>
          <button tuiButton appearance="" (click)="toggle()">
            <div class="flex justify-center items-center btn-outline w-[80px] sm:w-[160px]">
              <tui-svg src="tuiIconSlidersLarge" class="sm:pt-3 rotate-90 flex items-center"
                style="color: #bb0021;"></tui-svg>
              <p class="hidden sm:block">Advanced Search</p>
            </div>
          </button>
        </div>
        <div>
          <button tuiButton appearance="" (click)="navigateToAdd()">
            <div class="flex justify-center items-center w-[180px] sm:w-[160px] btn-outline">
              <p class="flex justify-center items-center text-[13px] h-[24px]">Add Inventory</p>
            </div>
          </button>
        </div>
      </div>
    </div>

    <tui-loader [overlay]="true" [showLoader]="isLoading">
      <!-- Advanced Search -->
      <div class="mt-2 sm:mt-0 mb-3" *ngIf="showSearch">
        <div class="flex sm:items-center gap-1 flex-col sm:flex-row">
          <div class="w-full sm:w-60">
            <tui-input tuiTextfieldIconLeft="tuiIconSearchLarge" [tuiTextfieldCleaner]="true"
              tuiTextfieldSize="m" [tuiTextfieldLabelOutside]="true" [(ngModel)]="searchText"
              (tuiValueChanges)="cancelSearch($event)">
              Search
              <input tuiTextfield type="text" />
            </tui-input>
          </div>

          <div class="w-full sm:w-[100px] my-3">
            <button tuiButton tuiTextfieldSize="s" type="button" class="w-full" (click)="search()">
              <tui-svg src="tuiIconSearchLarge" class="pr-2 text-white"></tui-svg>
              <span class="text-white">Search</span>
            </button>
          </div>
        </div>

        <!-- Status / Reset -->
        <div class="flex justify-between p-2 pr-5 bg-[#faf0f2] rounded mt-2 w-full" *ngIf="statusMsg">
          <div class="flex items-center">
            <img src="/assets/img/resulticon.png" alt="">
            <p class="text-black pl-2">{{ showText() }}</p>
          </div>
          <div>
            <button class="text-[#bb0021] hover:scale-110 transition-all duration-100" (click)="resetStatus()">
              Reset
            </button>
          </div>
        </div>
      </div>

      <!-- Inventory Table -->
      <div class="mt-3">
        <div *ngIf="filteredList.length > 0" class="overflow-x-scroll" style="white-space: nowrap">
          <table class="tui-table w-full">
            <thead tuiThead>
              <tr class="tui-table__tr">
                <th class="tui-table__th">Item ID</th>
                <th class="tui-table__th">Item Name</th>
                <th class="tui-table__th">Quantity</th>
                <th class="tui-table__th">Price (LKR)</th>
                <th class="tui-table__th">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr class="tui-table__tr" *ngFor="let item of filteredList">
                <td class="tui-table__td">{{ item.itemId }}</td>
                <td class="tui-table__td">{{ item.name }}</td>
                <td class="tui-table__td">x{{ item.quantity }}</td>
                <td class="tui-table__td">{{ item.price | number:'1.2-2' }}</td>
                <td class="tui-table__td">
                  <div class="flex items-center justify-between" style="width:100px;">
                    <!-- Edit -->
                    <a class="text-[#bb0021] hover:scale-110 transition-all duration-100"
                      style="cursor: pointer;" (click)="updateItem(item)">Edit</a>

                    <!-- Dropdown -->
                    <button [tuiDropdown]="dropdownContent" [tuiDropdownManual]="item.dropdownOpen"
                      (click)="item.dropdownOpen = !item.dropdownOpen"
                      (tuiActiveZoneChange)="item.dropdownOpen = !!$event"
                      (tuiObscured)="item.dropdownOpen = false">
                      <tui-svg src="tuiIconMoreVertical"
                        class="hover:scale-110 transition-all duration-100"></tui-svg>

                      <ng-template #dropdownContent>
                        <div class="dropdown dropdownContent" (click)="item.dropdownOpen = false">
                          Send Restock<br />Reminder
                        </div>
                        <div class="dropdown dropdownContent" style="color: red"
                          (click)="deleteItem(item); item.dropdownOpen = false">Delete
                        </div>
                      </ng-template>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- No Data -->
        <div *ngIf="filteredList.length === 0 && !isLoading" class="mt-3">
          <p class="text-[#D8D8D8] text-center">No Data</p>
        </div>
      </div>
    </tui-loader>
  </div>
</div>
